<script>

import {
  notificationMethods
} from "@/state/helpers";

import appConfig from "@/app.config";
import DeviceDetectionMixin from "@/mixins/DeviceDetectionMixin";
import user from "@/mixins/user";

/**
 * Auth-login component
 */
export default {
  mixins: [ DeviceDetectionMixin, user ],
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description
      }
    ]
  },
  data() {
    return {
      user_cd: "",
      password: "",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    notificationAutoCloseDuration() {
      return this.$store && this.$store.state.notification ? 5 : 0;
    }
  },
  methods: {
    ...notificationMethods,
    async tryToLogIn() {
      this.authError = null;
      const resultLogin = await this.$store.dispatch("auth/login", {
        user_cd: this.user_cd,
        password: this.password
      });

      if (resultLogin.status) {
        let rootScreenUrl = this.getRootScreenUrl();
        this.$router.push({ path: rootScreenUrl });

        return;
      }

      this.authError = resultLogin.errors;
    },
    isInputError(input) {
      if (!this.authError) return false;

      return !!this.authError[input];
    }
  }
};
</script>

<template>
  <div class="account-pages my-5 pt-sm-5">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-8">
          <div class="card overflow-hidden">
            <div class="row g-0">
              <div class="col-lg-12">
                <div class="p-lg-5 p-4">
                  <div class="mt-4 pt-3">
                    <form @submit.prevent="tryToLogIn">
                      <div class="mb-3">
                        <label for="user_cd" class="fw-semibold">ID</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="user_cd"
                          id="user_cd"
                          placeholder="IDを入力してください"
                          :class="{
                            'is-invalid': isInputError('user_cd')
                          }"
                          maxlength="255"
                        />
                        <div
                          v-if="isInputError('user_cd')"
                          class="invalid-feedback"
                        >
                          {{ authError["user_cd"][0] }}
                        </div>
                      </div>

                      <div class="mb-3 mb-4">
                        <label for="userpassword" class="fw-semibold"
                          >パスワード</label
                        >
                        <input
                          type="password"
                          v-model="password"
                          class="form-control"
                          id="userpassword"
                          placeholder="パスワードを入力してください"
                          :class="{
                            'is-invalid': isInputError('password')
                          }"
                          maxlength="255"
                        />
                        <div
                          v-if="isInputError('password')"
                          class="invalid-feedback"
                        >
                          {{ authError["password"][0] }}
                        </div>
                      </div>

                      <div class="row align-items-center">
                        <div class="text-end">
                          <button
                            class="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            ログイン
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end card -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end account page -->
</template>
